import { render, staticRenderFns } from "./MobileFooterPortal.vue?vue&type=template&id=4d9bdc14&"
import script from "./MobileFooterPortal.vue?vue&type=script&lang=ts&"
export * from "./MobileFooterPortal.vue?vue&type=script&lang=ts&"
import style0 from "./MobileFooterPortal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports